import TrackElements from '@capsule/track-elements'

export default class ArticleOrderedContentList {
	private contentListItems: NodeListOf<HTMLAnchorElement>

	constructor() {
		this.contentListItems = document.querySelectorAll(
			'.articleOrderedContentList .orderedContentList-link'
		)
	}

	init() {
		this.initTrackingElements()
	}

	initTrackingElements() {
		if (this.contentListItems.length) {
			const trackingEntries = [...this.contentListItems].map((listItem, index) => ({
				element: listItem,
				click: {
					event: 'navigation_click',
					navigation_type: 'most-read-articles',
					navigation_label: 'les-plus-lus',
					navigation_name: `article-${index + 1}`
				}
			}))
			const trackElements = new TrackElements(trackingEntries)
			trackElements.init()
		}
	}
}
